var map = {
	"./af.json": 3522,
	"./am.json": 6095,
	"./ar.json": 9661,
	"./az.json": 4506,
	"./be.json": 1866,
	"./bg.json": 3662,
	"./bn.json": 6589,
	"./bs.json": 2434,
	"./ca.json": 4602,
	"./cs.json": 6611,
	"./cy.json": 5077,
	"./da.json": 5774,
	"./de.json": 8491,
	"./dv.json": 6789,
	"./el.json": 3468,
	"./en.json": 1086,
	"./es.json": 6655,
	"./et.json": 843,
	"./eu.json": 6939,
	"./fa.json": 6560,
	"./fi.json": 3772,
	"./fr.json": 924,
	"./gl.json": 5627,
	"./ha.json": 7940,
	"./he.json": 1562,
	"./hi.json": 3529,
	"./hr.json": 2634,
	"./hu.json": 817,
	"./hy.json": 3138,
	"./id.json": 9381,
	"./is.json": 6643,
	"./it.json": 7384,
	"./ja.json": 4910,
	"./ka.json": 4652,
	"./kk.json": 5636,
	"./km.json": 7309,
	"./ko.json": 5979,
	"./ku.json": 6150,
	"./ky.json": 3591,
	"./lt.json": 2416,
	"./lv.json": 1757,
	"./mk.json": 620,
	"./ml.json": 4924,
	"./mn.json": 2849,
	"./ms.json": 8954,
	"./nb.json": 4451,
	"./nl.json": 7613,
	"./nn.json": 4636,
	"./no.json": 1189,
	"./pl.json": 6238,
	"./ps.json": 1766,
	"./pt.json": 9562,
	"./ro.json": 8795,
	"./ru.json": 1963,
	"./sd.json": 4726,
	"./sk.json": 2201,
	"./sl.json": 6926,
	"./so.json": 5791,
	"./sq.json": 6774,
	"./sr.json": 1376,
	"./sv.json": 2552,
	"./sw.json": 9310,
	"./ta.json": 8517,
	"./tg.json": 8210,
	"./th.json": 5188,
	"./tr.json": 3054,
	"./tt.json": 3785,
	"./ug.json": 9019,
	"./uk.json": 4076,
	"./ur.json": 4819,
	"./uz.json": 4039,
	"./vi.json": 4546,
	"./zh.json": 6637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7467;